import React from "react";

import * as auto_pi from "@crochik/auto-pi";

const FormContext = React.createContext<auto_pi.Form | undefined>(undefined);

interface Props {
    form: auto_pi.Form;
    children: React.ReactNode;
}

export const FormProvider = (props: Props) => {
    return <FormContext.Provider value={props.form}>{props.children}</FormContext.Provider>;
};

export const useForm = () => {
    const value = React.useContext(FormContext);
    if (!!value) {
        return value;
    }
    throw new Error("Invalid context. Are you missing a FormProvider?");
};
